import each from "lodash/fp/each";
import first from "lodash/fp/first";
class Controller {
  constructor(Events, $mdDialog, Lists) {
    "ngInject";

    this.Events = Events;
    this.Lists = Lists.all;
    this.$mdDialog = $mdDialog;
    this.cancellationRulesTimeDefault = first(
      this.Lists.cancellationRulesTimeOptions
    );
    this.cancellationRulesAnchorDefault = first(
      this.Lists.cancellationRulesAnchorOptions
    );
    this.isRulesEditable = false;
  }

  $onInit() {
    const mapSelected = (selected) => {
      if (this.selectTitle && selected.selectedItemInList) {
        selected[this.selectTitle.toLowerCase()] = selected.selectedItemInList;
        return selected;
      }
      return selected;
    };

    this.items = this.items || [];

    this.addNewItem = () => {
      const type = this.cancellationRulesTimeDefault;
      const anchor = this.cancellationRulesAnchorDefault;
      const item = this.isRules
        ? { isDisabled: false, type, anchor }
        : { isDisabled: false };
      item.selectedItemInList = "";
      this.items.push(item);
    };
    if (this.isRequired) this.addNewItem();

    this.toggleRules = () => {
      this.isRulesEditable = true;
    };

    this.editItem = (index) => {
      this.items[index].isDisabled = false;
    };

    this.removeItem = (index) => {
      if (this.showSave) {
        const confirm = this.$mdDialog
          .confirm()
          .title(`Are you sure you want to remove "${this.name}"?`)
          .textContent("If you chose to remove it you can add it again.")
          .ok("Remove")
          .cancel("Cancel");

        this.$mdDialog.show(confirm).then(
          () => {
            this.items.splice(index, 1);
            this.saveItems();
          },
          () => {}
        );
      } else {
        if (this.isRequired && index === 0) return;
        this.items.splice(index, 1);
        this.saveItems();
      }
    };

    this.saveItems = () => {
      this.isRulesEditable = false;
      const options = {};
      this.items.map(mapSelected);
      options[this.name] = this.items;
      options.name = this.name;
      each((item) => {
        item.isDisabled = true;
      })(this.items);
      this.Events.emit(
        this.eventName,
        Object.assign({}, options, this.extraData)
      );
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/listItems/listItems.controller.js